/**
 * React Query hooks for Tag operations.
 */

import { useQuery } from '@tanstack/react-query';
import tagService from '../services/tag.service';

interface UseTagListQueryParams {
  workspaceId: string | undefined;
  idToken: string | undefined;
  search?: string;
  enabled?: boolean;
}

export const useTagListQuery = ({
  workspaceId,
  idToken,
  search,
  enabled = true,
}: UseTagListQueryParams) => {
  return useQuery({
    queryKey: ['tags', workspaceId, search],
    queryFn: async () => {
      if (!workspaceId || !idToken) {
        throw new Error('Workspace ID and token are required');
      }
      return tagService.listTags(workspaceId, idToken, { search, limit: 10 });
    },
    enabled: enabled && !!workspaceId && !!idToken,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};
